// extracted by mini-css-extract-plugin
module.exports = {"fontItem":"otkit-typography-desktop-module--font-item--W_aj9","mainContainer":"otkit-typography-desktop-module--main-container--20br3"};